import ApplicationController from './application_controller';

const TEMPLATES = {
  'no-title': '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-content"></div></div>'
};

/**
 * Activa un popover de un elemento al igual que lo hace bootstrap pero con peculiaridades
 * especiales de Cifra para mantener el popover abierto etc
 */
/* global $ */
export default class extends ApplicationController {
  connect() {
    this.$element = $(this.element);
    this.inicializarComponente();
  }

  inicializarComponente() {
    const popoverSettings = {};
    const template = this.$element.data('popover-template');
    if (TEMPLATES[template]) {
      popoverSettings.template = TEMPLATES[template];
    }
    // Si el container es "this", ponemos al propio elemento. Con esto ganamos
    // que al mover el ratón sobre el popover no se cierre porque está dentro
    // del container
    if (this.$element.data('container') === 'this') {
      popoverSettings.container = this.$element;
    } else if (this.$element.data('container') === 'parent') {
      popoverSettings.container = this.$element.parent();
    }

    if (this.$element.data('trigger') === 'hoverpersist') {
      popoverSettings.trigger = 'manual';
      this.#popoverTriggerHoverpersist();
    }

    this.$element.popover(popoverSettings);
    const popoverClass = this.$element.data('popover-class');
    if (popoverClass) {
      this.$element.data('bs.popover').tip().addClass(popoverClass);
    }
  }

  // Conecta los eventos para mostrar el popover al hacer el hover sobre el
  // elemento pero no lo esconde hasta que el ratón no esté fuera del elemento
  // y fuera del popover. Es decir, mantiene el popover visible mientras el ratón
  // esté encima de él
  #popoverTriggerHoverpersist() {
    const $el = this.$element;
    $el.on('mouseenter', function onEnter() {
      const elementoParaHover = this;
      $(this).popover('show');
      $('.popover').on('mouseleave', () => {
        $(elementoParaHover).popover('hide');
      });
    }).on('mouseleave', function onLeave() {
      const elementoParaHover = this;
      setTimeout(() => {
        if (!$('.popover:hover').length) {
          $(elementoParaHover).popover('hide');
        }
      }, 100);
    });
  }
}
